import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('accountant');
export interface AccountantInfoRec {
  id: string;
  userId: string;
  firmName?: string;
  accountantName?: string;
  credentials?: string;
  officeAddress?: string;
  officePhone?: string;
  cellPhone?: string;
  email?: string;
  website?: string;
  licenseNumber?: string;
  hourlyRate?: number;
  annualFee?: number;
  servicesProvided?: string;
  notes?: string;
  isLocked?: boolean;
}

class AccountantInfoService {
  async getAllAccountantInfo(targetUserId?: string): Promise<AccountantInfoRec[]> {
    const params = targetUserId ? `?targetUserId=${targetUserId}` : '';
    const response = await http.get(`/api/accountant-info${params}`);

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch accountant information');
    }

    return response.data.data || [];
  }

  async getAccountantInfo(targetUserId?: string): Promise<AccountantInfoRec[]> {
    return this.getAllAccountantInfo(targetUserId);
  }

  async createAccountantInfo(data: Partial<AccountantInfoRec>): Promise<AccountantInfoRec> {
    const response = await http.post('/api/accountant-info', data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to save accountant information');
    }

    return response.data.data;
  }

  async updateAccountantInfo(id: string, data: Partial<AccountantInfoRec>): Promise<AccountantInfoRec> {
    const response = await http.patch(`/api/accountant-info/${id}`, data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to update accountant information');
    }

    return response.data.data;
  }

  async deleteAccountantInfo(id: string): Promise<void> {
    const response = await http.delete(`/api/accountant-info/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to delete accountant information');
    }
  }

  async lockAccountantInfo(id: string): Promise<void> {
    logger.debug('[Service Debug] Calling lock API for accountant ID:', id);
    const response = await http.post(`/api/accountant-info/${id}/lock`);
    logger.debug('[Service Debug] Lock API response:', response.data);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to lock accountant information');
    }
  }

  async unlockAccountantInfo(id: string, granteeEmails: string[]): Promise<void> {
    const response = await http.post(`/api/accountant-info/${id}/unlock`, { granteeEmails });
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to unlock accountant information');
    }
  }

  async getAccountantAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/accountant-info/${id}/access-grants`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch access grants');
    }

    return response.data.data || [];
  }
}

export const accountantInfoService = new AccountantInfoService();
























